import {
  Button,
  NavBar,
  Icon,
  Toast,
  Tabs,
  WhiteSpace,
  SearchBar,
} from "antd-mobile";
//   import { ProductionTaskRejectStatItemDTO } from "../../schema";
import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router";
import styled from "styled-components";
const JixiaoList = styled.div`
  .kaohe1 {
    width: 100%;
    height: 60px;
    border: 1px solid #d7d7d7;
    border-radius: 5px;
    text-align: center;
    line-height: 60px;
    font-size: 20px;
    color: #555555;
    margin-bottom: 10px;
  }
  .pdd {
    padding: 0 10px 0 10px;
  }
`;
export default function YearAssessment() {
  const GridStyle: React.CSSProperties = {
    padding: "5px 0",
  };
  const [tankuang, setTankuang] = useState<{
    visible: boolean;
    rejectId?: string;
    userId?: string;
  }>({
    visible: false,
  });
  const history = useHistory();
  const [text, setText] = useState<string>("");
  useEffect(() => {
    let url = window.location.href; //获取请求进来的完整url
    // let tstr = url.substring(url.indexOf('?') + 1).split('&');//先截取url的?后面的参数部分，在根据&分割成参数数组
    let tstr = url.substring(url.indexOf("=") + 1); //获取uuid
    // console.log(tstr)
    setText(tstr);
  }, []);
  return (
    <>
      <JixiaoList>
        <div className="body">
          <NavBar
            className="orderNavBar"
            icon={
              <Icon
                type="left"
                onClick={() => {
                  // history.push(
                  //     `/hr/jxassessment`
                  // );
                  history.go(-1);
                }}
              />
            }
          >
            年度绩效考核
          </NavBar>
          <WhiteSpace />
          <WhiteSpace />
          <WhiteSpace />
          <WhiteSpace />
          <div className="pdd">
            <div
              className="kaohe1"
              onClick={() => {
                window.location.href =
                  "/hr/jxassessment/yearassessment/organization?vSheetId=" +
                  text;
              }}
            >
              组织绩效考核
            </div>
            <WhiteSpace />
            <div
              className="kaohe1"
              onClick={() => {
                window.location.href =
                  "/hr/jxassessment/yearassessment/staff?vSheetId=" + text;
              }}
            >
              员工绩效考核
            </div>
          </div>
        </div>
      </JixiaoList>
    </>
  );
}
